import React from "react";
import { Grid, IconButton, Typography } from "@material-ui/core";
import InputField from "src/components/ui-components/InputField";
import SwitchField from "src/components/ui-components/SwitchField";
import { FieldArray } from "formik";
import { Delete } from "@material-ui/icons";

const MenuFilterValueCreateEdit = ({ formRef, index }) => {
  return (
    <FieldArray name={`pageFilter.${index}.pageFilterValues`}>
      {({ push, remove }) => (
        <>
          {formRef?.current?.values?.pageFilter[index]?.pageFilterValues?.map(
            (pageFilterValue, idx) => (
              <>
                <Typography variant="h6" gutterBottom sx={{ marginBottom: 3 }}>
                  Menu Filter Value {idx + 1}
                  <IconButton onClick={() => remove(idx)}>
                    <Delete style={{ fontSize: 20 }} />
                  </IconButton>
                </Typography>
                <Grid container spacing={5}>
                  <Grid container item spacing={3}>
                    <Grid item xs={6}>
                      <InputField
                        label="Menu Filter Value Name"
                        name={`pageFilter.${index}.pageFilterValues.${idx}.pageFilterValueName`}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <InputField
                        label="Menu Filter Value"
                        name={`pageFilter.${index}.pageFilterValues.${idx}.pageFilterValue`}
                      />
                    </Grid>
                    <Grid item xs={6} sx={{ marginBottom: 5 }}>
                      <InputField
                        label="Sort Order"
                        name={`pageFilter.${index}.pageFilterValues.${idx}.sortOrder`}
                      />
                    </Grid>
                    <Grid item xs={3} sx={{ marginBottom: 5 }}>
                      <SwitchField
                        name={`pageFilter.${index}.pageFilterValues.${idx}.isDefault`}
                        label="Is Default"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )
          )}
        </>
      )}
    </FieldArray>
  );
};

export default MenuFilterValueCreateEdit;
